import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("opl_token")) {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("opl_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("opl_token");
    setUser(false);
  };
  const can = (...perms) => !!user && perms.some((p) => user.permissions?.includes(p));
  return <AuthCtx.Provider value={{ user, login, logout, can }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function homeFor(user) {
  if (!user) return "/login";
  if (user.role === "team_owner") return "/owner";
  if (user.role === "auctioneer") return "/admin/live";
  if (user.role === "viewer") return "/live";
  return "/admin";
}

export function Protected({ perms, children }) {
  const { user, can } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-400" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (perms && !can(...perms))
    return (
      <div className="min-h-[60vh] grid place-items-center text-center p-8" data-testid="access-denied">
        <div>
          <p className="eyebrow">Access denied</p>
          <h2 className="text-2xl font-bold mt-2">You don't have permission to view this page</h2>
        </div>
      </div>
    );
  return children;
}
